import React from 'react';
import SVGInline from "react-svg-inline"
import subLogoSVG from '../inlineSVGs/subLogoSVG';
import './styles.css';

import PropTypes from 'prop-types';

const Footer = ({ onPress, openContact, filterChange, datatypes, isShowFooter }) => {
    const renderContact = (contact) => {
        if (!contact) return;

        return contact.split('\n').map((item, i) => {
            return (
                <span key={i}>
                    {item}
                    <br/>
                </span>
            )
        })
    };

    const renderAbout = aboutText => {
        return aboutText
    };


    if (!isShowFooter) return null;

    // http://terms.mugics.com/privacy.html
    return (
        <div className={`footer-wrapper rtl ${!isShowFooter ? 'hide' : ''}`}>
            <div className="links-wrapper">
                <div className="footer-cell about">
                    <p>הצטרפו אלינו</p>
                    <p className="footer-address first">{renderAbout(datatypes && datatypes.defaults && datatypes.defaults.joinUsText)}</p>

                </div>
                <div className="footer-cell contact">
                    <p>מיקום</p>
                    <p className="footer-address first">{renderContact(datatypes && datatypes.defaults && datatypes.defaults.contact)}</p>
                </div>

                <div className="footer-cell terms">
                    <p>תנאים</p>
                    <ul>
                        <li><a href="http://terms.mugics.com/terms-and-conditions.html" target="_blank" rel="noopener noreferrer">תנאי שימוש</a></li>
                        <li><a href="http://terms.mugics.com/privacy.html" target="_blank" rel="noopener noreferrer">מדיניות פרטיות</a></li>
                    </ul>
                </div>
                <div className="footer-cell use-mugics">
                    <p>שימוש ב-Mugics</p>
                    <ul>
                        <li><a onClick={() => filterChange('liveMusic')}>הופעות חיות ואירועים</a></li>
                        <li><a onClick={() => filterChange('service')}>שירותי מוזיקה ועסקים</a></li>
                        <li><a onClick={() => filterChange('band')}>להקות ונגנים</a></li>
                        <li><a onClick={onPress}>השתתפו</a></li>
                    </ul>
                </div>
                <div className="footer-cell connect-with-us">
                    <p>יצירת קשר</p>
                    <ul>
                        <li><a onClick={openContact}>שלחו הודעה</a></li>
                        <li><a href="https://twitter.com/MugicsApp" target="_blank" rel="noopener noreferrer">טוויטר</a></li>
                        <li><a href="https://www.facebook.com/mugics.app.94" target="_blank" rel="noopener noreferrer">פייסבוק</a></li>
                        <li><a href="https://www.instagram.com/mugicsapp/" target="_blank" rel="noopener noreferrer">אינסטגרם</a></li>
                    </ul>
                </div>
            </div>
            <div className="rights">
                {/*<p>(c) 2024</p>*/}
                <SVGInline svg={subLogoSVG('#FFFFFF')} component="i" width="120px"/>
            </div>
        </div>
    )
};

Footer.propTypes = {
    onPress: PropTypes.func,
    openContact: PropTypes.func,
    openPayingMethods: PropTypes.func,
    filterChange: PropTypes.func,
    datatypes: PropTypes.object,
    isShowFooter: PropTypes.bool
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js